import React from 'react';
import { Layout } from 'antd';
import AppNavbar from '../AppNavbar/AppNavbar';
import StyledAppHeader from './AppHeader.styles';

const AppHeader: React.FC = (): React.ReactElement => {
    const { Header } = Layout;
    return (
        <StyledAppHeader>
            <Header>
                <AppNavbar />
            </Header>
        </StyledAppHeader>
    );
};

export default AppHeader;
